import { IconMoon } from '@consta/icons/IconMoon'
import { IconSun } from '@consta/icons/IconSun'
import { ThemeToggler } from '@consta/uikit/ThemeToggler'
import type { FC } from 'react'

import type { Theme } from './ThemeStore'
import { themes, useGeomateTheme } from './ThemeStore'

function getItemIcon(value: Theme) {
  switch (value) {
    case 'dark':
      return IconMoon
    case 'light':
      return IconSun
  }
}

function identity<T>(value: T): T {
  return value
}

type ThemeSwitchProps = {
  className?: string
}

export const ThemeSwitch: FC<ThemeSwitchProps> = ({ className }) => {
  const [theme, setTheme] = useGeomateTheme()

  return (
    <ThemeToggler
      className={`${className} Button_form_round`}
      size="s"
      items={themes}
      value={theme}
      getItemKey={identity}
      getItemLabel={identity}
      getItemIcon={getItemIcon}
      onChange={setTheme}
    />
  )
}
